import axios, { AxiosError } from "axios";
const VehicleHireResource = {
    getVehicleHire(vehicleHireId, resultFunc, errorFunc, finallyFunc) {
        axios.get(`/admin/v1/vehicle-hires/${vehicleHireId}`)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    }
};
export default VehicleHireResource;
